import React, { useContext, useEffect, useState } from 'react';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextField
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import ReactLoading from 'react-loading';
import {
  differenceInMinutes,
  isPast,
  isToday,
  isWeekend,
  isValid,
  getHours,
  parseISO,
  format,
  addDays
} from 'date-fns';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ptBRLocale from 'date-fns/locale/pt-BR';
import { toast } from 'react-toastify';
import { StepButtons } from '../StepButtons';
import { halfHours as hours } from '../../../../helpers/hours';
import { useAuth } from '../../../../hooks/Auth';
import { useIntegration } from '../../../../hooks/Integration';
import { useManager } from '../../../../hooks/Manager';
import { usePickup } from '../../../../hooks/Pickup';
import { ReverseCollectContext } from '../..';
import { Title, TooltipIcon, TooltipWrapper } from './styled';

import Toast from '../../../../components/Toast';
import { options } from '../../../../helpers/toastOptions';
import { generateListFromInterval } from '../../../../helpers/hoursInterval';

export const LoadData = () => {
  const [transportSelected, setTransportSelected] = useState('');
  const [materialSelected, setMaterialSelected] = useState('');
  const [checkList, setCheckList] = useState([]);
  const [enableCheckList, setEnableCheckList] = useState(true);
  const [disabledMaterialDetail, setDisabledMaterialDetail] = useState(false);
  const [inputAvailableDate, setInputAvailableDate] = useState(parseISO(''));
  const [fromHours, setFromHours] = useState([]);
  const [toHours, setToHours] = useState([]);
  const [holidayList, setHolidayList] = useState([]);
  const [enablePickupOnWeekends, setEnablePickupOnWeekends] = useState(false);
  const [hourLimitOnWeekends, setHourLimitOnWeekends] = useState(0);
  const [enablePickupOnHolidays, setEnablePickupOnHolidays] = useState(false);
  const [hourLimitOnHolidays, setHourLimitOnHolidays] = useState(0);
  const [enableSlotTimeToPickupSchedule, setEnableSlotTimeToPickupSchedule] =
    useState(false);
  const [hourSlotTimeToPickupSchedule, setSlotTimeToPickupSchedule] =
    useState(0);
  const [minuteSlotTimeToPickupSchedule, setMinuteSlotTimeToPickupSchedule] =
    useState(0);
  const [isLoadingModal, setIsLoadingModal] = useState(true);
  const [isLoadingMaterial, setIsLoadingMaterial] = useState(true);
  const [isFirstRender, setIsFirstRender] = useState(true);

  const maxSM = useMediaQuery('(max-width:768px)');
  const maxMD = useMediaQuery('(max-width:900px)');

  const {
    transportTypeList,
    setTransportTypeList,
    setTransportSelectedToModal,
    freightTypeList,
    materialTypeList,
    setMaterialTypeList,
    otherMaterialId,
    setOtherMaterialId,
    checkListSelected,
    setCheckListSelected,
    openAcceptTransportTermsModal,
    customerAcceptGuidelines,
    setCustomerAcceptGuidelines,
    collectSenderData,
    collectRecipientData,
    collectLoadData,
    setCollectLoadData,
    openReceiveCollectInfoModal,
    collectLoadAvailabilityData,
    setCollectLoadAvailabilityData,
    handleNextStep
  } = useContext(ReverseCollectContext);

  const { getBranchDetails, getHolidaysByZipPostalCode } = useIntegration();
  const {
    getPickupManagerParameterization,
    getPickupManagerParameterizationTransportTypes,
    getPickupManagerBranchGeneralConfig,
    getPickupManagerMaterialListEnabled,
    getPickupManagerCheckList,
    getPickupManagerBranchValidations,
    getPickupManagerBranchSchedules
  } = useManager();

  const collectLoadSchema = Yup.object().shape({
    modal: Yup.string().required('Modal obrigatório').trim('Modal obrigatório'),
    freight: Yup.string()
      .required('Frete obrigatório')
      .trim('Frete obrigatório'),
    // material: Yup.string()
    //   .required('Material obrigatório')
    //   .trim('Material obrigatório'),
    // MaterialDetail: Yup.string().when('material', {
    //   is: `${otherMaterialId}`,
    //   then: Yup.string()
    //     .required('Detalhes do material obrigatório')
    //     .trim('Detalhes do material obrigatório')
    // }),
    loadVolume: Yup.string()
      .required('N° de volumes obrigatório')
      .trim('N° de volumes obrigatório')
      .test('loadVolumeTest', 'Volume inválido', (value) => {
        const parsedValue = value;
        return parsedValue > 0;
      }),
    loadWeight: Yup.string()
      .required('Peso total obrigatório')
      .trim('Peso total obrigatório')
      .test('loadWeightTest', 'Peso total inválido', (value) => {
        const parsedValue = Number(value.replaceAll('.', '').replace(',', '.'));
        return parsedValue > 0;
      }),
    // loadHeight: Yup.string()
    //   .required('Altura obrigatória')
    //   .trim('Altura obrigatória')
    //   .test('loadHeightTest', 'Altura inválida', (value) => {
    //     const parsedValue = Number(value.replaceAll('.', '').replace(',', '.'));
    //     return parsedValue > 0;
    //   }),
    // loadWidth: Yup.string()
    //   .required('Largura obrigatória')
    //   .trim('Largura obrigatória')
    //   .test('loadWidthTest', 'Largura inválida', (value) => {
    //     const parsedValue = Number(value.replaceAll('.', '').replace(',', '.'));
    //     return parsedValue > 0;
    //   }),
    // loadLength: Yup.string()
    //   .required('Comprimento obrigatório')
    //   .trim('Comprimento obrigatório')
    //   .test('loadLengthTest', 'Comprimento inválido', (value) => {
    //     const parsedValue = Number(value.replaceAll('.', '').replace(',', '.'));
    //     return parsedValue > 0;
    //   }),
    acceptTerms: Yup.boolean(),
    loadAvailableDate: Yup.string()
      .required('Data obrigatória')
      .test(
        'loadAvailableDateTest',
        'A data de coleta deverá ser maior que a data de hoje!',
        (value) => {
          return !(isPast(new Date(value)) || isToday(new Date(value)));
        }
      )
      .test(
        'loadAvailableDateWeekendTest',
        'Preencha o campo apenas com dias úteis!',
        (value) => {
          if (!enablePickupOnWeekends && isWeekend(new Date(value))) {
            return false;
          }

          if (
            !enablePickupOnHolidays &&
            holidayList?.includes(new Date(value).toDateString())
          ) {
            return false;
          }

          return true;
        }
      )
      .nullable(),
    loadAvailableFrom: Yup.string().required('Hora obrigatória').nullable(),
    loadAvailableUntil: Yup.string()
      .required('Hora obrigatória')
      .test(
        'loadAvailableUntilTest',
        'Hora final deve ser após hora inicial',
        (value, ctx) => {
          const fromDate = new Date(
            2000,
            0,
            1,
            ctx.parent.loadAvailableFrom.split(':')[0],
            ctx.parent.loadAvailableFrom.split(':')[1]
          );

          const untilDate = new Date(
            2000,
            0,
            1,
            value.split(':')[0],
            value.split(':')[1]
          );

          return !(differenceInMinutes(fromDate, untilDate) >= 0);
        }
      )
      .nullable()
  });

  const {
    handleSubmit,
    control,
    setValue,
    getValues,
    setError,
    clearErrors,
    watch,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(collectLoadSchema),
    mode: 'onBlur',
    reValidateMode: 'onChange'
  });

  // const handleChangeMaterialType = (value) => {
  //   if (value === otherMaterialId) {
  //     setDisabledMaterialDetail(false);
  //   } else {
  //     setDisabledMaterialDetail(true);
  //     setValue('MaterialDetail', '');
  //     clearErrors('MaterialDetail');
  //   }
  // };

  const disableDays = (date) => {
    let isHoliday = false;

    if (holidayList?.length > 0) {
      const newDate = new Date(date).toDateString();

      isHoliday = holidayList?.includes(newDate);
    }

    return (
      (!enablePickupOnWeekends &&
        (date.getDay() === 0 || date.getDay() === 6)) ||
      (!enablePickupOnHolidays && isHoliday)
    );
  };

  const onNextStep = (data) => {
    if (!customerAcceptGuidelines && checkListSelected?.branchChecklistId) {
      toast(
        <Toast
          title="Atenção!"
          type="error"
          content="Aceite as orientações gerais de transporte."
        />,
        options
      );

      return;
    }

    if (
      !isValid(new Date(data.loadAvailableDate)) ||
      format(new Date(data.loadAvailableDate), 'yyyy')?.replace(/^0+/, '')
        ?.length < 4
    ) {
      setError('loadAvailableDate', {
        message: 'A data de coleta informada é inválida!'
      });
      return;
    }

    const dateDigit = new Date();

    const thirtyDays = new Date(addDays(dateDigit, 30));

    if (new Date(data.loadAvailableDate) > thirtyDays) {
      setError('loadAvailableDate', { message: 'Data inválida' });
      return;
    }

    setCollectLoadData(data);

    const date = new Date(data.loadAvailableDate).toISOString().split('T')[0];

    let [hour] = data.loadAvailableFrom.split(':');
    // const pickupFromDate = `${date}T${String(hour).padStart(2, '0')}:00:00.000`;
    const minutesFromDate = data.loadAvailableFrom.split(':')[1];
    const pickupFromDate = `${date}T${String(hour).padStart(
      2,
      '0'
    )}:${minutesFromDate}:00.000`;

    [hour] = data.loadAvailableUntil.split(':');
    // const pickupUntilDate = `${date}T${String(hour).padStart(
    //   2,
    //   '0'
    // )}:00:00.000`;
    const minutesUntilDate = data.loadAvailableUntil.split(':')[1];
    const pickupUntilDate = `${date}T${String(hour).padStart(
      2,
      '0'
    )}:${minutesUntilDate}:00.000`;

    setCollectLoadAvailabilityData({
      pickupFromDate,
      pickupUntilDate,
      loadAvailableDate: data.loadAvailableDate,
      loadAvailableFrom: data.loadAvailableFrom,
      loadAvailableUntil: data.loadAvailableUntil
    });

    handleNextStep();
  };

  const formatInput = (value) => {
    value += '';

    if (value.length === 1) {
      value = `0,0${value}`;
    }

    value = value.replace(/[\D]+/g, '').replace(/([0-9]{2})$/g, ',$1');

    if (value.length > 6) {
      value = value.replace(/([0-9]{3}),([0-9]{2}$)/g, '.$1,$2');
    }

    if (value.charAt(0) === '0' && value.charAt(2) === ',') {
      value = value.substring(1);
    } else if (value.charAt(0) === ',') {
      value = `0${value}`;
    }

    return value === 'NaN' ? '' : value;
  };

  useEffect(() => {
    if (isToday(inputAvailableDate)) {
      const hour = getHours(new Date());

      const hoursFiltered = hours.filter((value) => {
        return value.hour.split(':')[0] > hour;
      });

      setFromHours(hoursFiltered);

      const { loadAvailableFrom } = getValues();

      const findHour = hoursFiltered.findIndex((value) => {
        return value.hour === loadAvailableFrom;
      });

      if (findHour < 0) {
        setValue('loadAvailableFrom', '');
      }
    } else {
      setFromHours(hours);
    }
  }, [inputAvailableDate]);

  useEffect(() => {
    const { loadAvailableFrom, loadAvailableUntil } = getValues();

    let newHours = [...hours];

    if (loadAvailableFrom && enablePickupOnWeekends) {
      const fromHour = String(loadAvailableFrom)?.split(':')[0];
      let maxHour = 24;

      if (isWeekend(inputAvailableDate)) {
        maxHour = hourLimitOnWeekends || 24;

        newHours = newHours.filter(({ hour }) => {
          return hour.split(':')[0] > fromHour && hour.split(':')[0] <= maxHour;
        });
      }
    }

    if (loadAvailableFrom && enablePickupOnHolidays) {
      const fromHour = String(loadAvailableFrom)?.split(':')[0];
      let maxHour = 24;

      if (holidayList?.includes(new Date(inputAvailableDate).toDateString())) {
        maxHour = hourLimitOnHolidays || 24;

        newHours = newHours.filter(({ hour }) => {
          return hour.split(':')[0] > fromHour && hour.split(':')[0] <= maxHour;
        });
      }
    }

    // if (loadAvailableFrom && enableSlotTimeToPickupSchedule) {
    //   const fromHour = String(loadAvailableFrom)?.split(':')[0];
    //   const interval = hourSlotTimeToPickupSchedule || 1;

    //   newHours = newHours.filter(({ hour }) => {
    //     return (
    //       hour.split(':')[0] > fromHour &&
    //       (hour.split(':')[0] - fromHour) % interval === 0
    //     );
    //   });
    // }
    if (loadAvailableFrom && enableSlotTimeToPickupSchedule) {
      const fromHour = String(loadAvailableFrom)?.split(':')[0];
      const fromMinute = String(loadAvailableFrom)?.split(':')[1];
      const interval = hourSlotTimeToPickupSchedule || 1;

      const intervalMinute = minuteSlotTimeToPickupSchedule;
      const listHoursInterval = generateListFromInterval(
        `${fromHour}:${fromMinute}`,
        `${interval}:${intervalMinute}`,
        newHours
      );
      newHours = listHoursInterval;
    }

    const findHour = newHours.find(({ hour }) => {
      return hour === loadAvailableUntil;
    });

    if (!findHour) {
      setValue('loadAvailableUntil', '');
    }

    setToHours(newHours);
  }, [inputAvailableDate, watch('loadAvailableFrom'), isFirstRender]);

  const onComponentDidMount = async () => {
    setIsLoadingModal(true);
    // setIsLoadingMaterial(true);
    setTransportTypeList([]);
    // setMaterialTypeList([]);

    try {
      const branchDetailsResponse = await getBranchDetails({
        params: { zip_code: collectSenderData?.address?.zipPostalCode }
      });

      const pickupManagerTransportTypesParams = {
        branchId: 1,
        pickupTypeId: 2,
        inputTypeId: 5
      };

      if (branchDetailsResponse?.length > 0) {
        pickupManagerTransportTypesParams.branchId =
          branchDetailsResponse[0].idFilial;
      }

      const pickupManagerParameterizationTransportTypesResponse =
        await getPickupManagerParameterizationTransportTypes({
          params: pickupManagerTransportTypesParams
        });

      if (pickupManagerParameterizationTransportTypesResponse.status === 200) {
        const { data: modalList } =
          pickupManagerParameterizationTransportTypesResponse?.data;

        if (modalList?.length > 0) {
          setTransportTypeList(modalList);
        }
      } else {
        const pickupManagerResponse = await getPickupManagerParameterization({
          branchId: 1,
          transportTypeId: 9,
          pickupTypeId: 1,
          inputTypeId: 5
        });

        if (pickupManagerResponse?.length > 0) {
          const generalConfigResponse =
            await getPickupManagerBranchGeneralConfig({
              branchParameterizationId:
                pickupManagerResponse[0]?.branchParameterizationId
            });

          if (generalConfigResponse?.length > 0) {
            const modalList = generalConfigResponse.filter(
              (config) => config.type === 'Modal' && config.enabled === true
            );

            if (modalList?.length > 0) {
              modalList?.map((value) => {
                if (value.description === 'Rodoviário') {
                  value.transportTypeId = 1;
                } else {
                  value.transportTypeId = 2;
                }

                return value;
              });

              setTransportTypeList(modalList);
            }
          }
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }

    try {
      const holidaysResponse = await getHolidaysByZipPostalCode({
        zipPostalCode: collectSenderData?.address?.zipPostalCode
      });

      if (holidaysResponse?.status === 200) {
        const holidays = holidaysResponse?.data?.data?.list.map((holiday) => {
          const date = new Date(holiday.date).toDateString();
          return date;
        });

        setHolidayList(holidays);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }

    setIsLoadingModal(false);
    // setIsLoadingMaterial(false);

    collectLoadData.modal && setValue('modal', collectLoadData.modal);
    collectLoadData.modal && setTransportSelected(collectLoadData.modal);
    collectLoadData.modal && setTransportSelectedToModal(collectLoadData.modal);
    collectLoadData.freight && setValue('freight', collectLoadData.freight);
    // collectLoadData.material && setValue('material', collectLoadData.material);
    // collectLoadData.material && setMaterialSelected(collectLoadData.material);
    collectLoadData.loadVolume &&
      setValue('loadVolume', collectLoadData.loadVolume);
    collectLoadData.loadWeight &&
      setValue('loadWeight', collectLoadData.loadWeight);
    // collectLoadData.loadHeight &&
    //   setValue('loadHeight', collectLoadData.loadHeight);
    // collectLoadData.loadWidth &&
    //   setValue('loadWidth', collectLoadData.loadWidth);
    // collectLoadData.loadLength &&
    //   setValue('loadLength', collectLoadData.loadLength);

    // if (collectLoadData.material && collectLoadData.material === '9999') {
    //   setValue('MaterialDetail', collectLoadData.MaterialDetail);
    // } else {
    //   setDisabledMaterialDetail(true);
    //   setValue('MaterialDetail', '');
    //   clearErrors('MaterialDetail');
    // }

    setFromHours(hours);
    setToHours(hours);

    if (collectLoadAvailabilityData.loadAvailableDate) {
      setValue(
        'loadAvailableDate',
        collectLoadAvailabilityData.loadAvailableDate
      );

      setInputAvailableDate(
        new Date(collectLoadAvailabilityData.loadAvailableDate)
      );
    }

    collectLoadAvailabilityData.loadAvailableFrom &&
      setValue(
        'loadAvailableFrom',
        collectLoadAvailabilityData.loadAvailableFrom
      );
    collectLoadAvailabilityData.loadAvailableUntil &&
      setValue(
        'loadAvailableUntil',
        collectLoadAvailabilityData.loadAvailableUntil
      );
  };

  useEffect(onComponentDidMount, []);

  useEffect(async () => {
    if (transportSelected === '') return;

    setIsLoadingMaterial(true);
    // setValue('material', '');
    // setMaterialSelected('');
    // setMaterialTypeList([]);
    // setOtherMaterialId('');
    setCheckListSelected({});
    setCheckList([]);

    try {
      const transportFounded = transportTypeList.find(
        (transport) =>
          String(transport.transportTypeId) === String(transportSelected)
      );

      let transportTypeId = 9;

      if (transportFounded) {
        transportTypeId = transportFounded?.branchGeneralConfigurationId;
      }

      const params = {
        branchId: 1,
        transportTypeId,
        pickupTypeId: 1,
        inputTypeId: 5
      };

      const branchDetailsParams = {
        zip_code: collectSenderData?.address?.zipPostalCode,
        transport_type: String(transportSelected) === '2' ? 'A' : 'R',
        sender_document: collectSenderData?.document
      };

      if (collectRecipientData?.document) {
        branchDetailsParams.receiver_document = collectRecipientData?.document;
      }

      const branchDetailsResponse = await getBranchDetails({
        params: branchDetailsParams
      });

      if (branchDetailsResponse?.length > 0) {
        params.branchId = branchDetailsResponse[0].idFilial;
        params.pickupTypeId = 2;
      }

      const pickupManagerResponse = await getPickupManagerParameterization(
        params
      );

      let branchParameterizationId;

      if (pickupManagerResponse?.length > 0) {
        branchParameterizationId =
          pickupManagerResponse[0]?.branchParameterizationId;
      }

      if (!branchParameterizationId) {
        const defaultPickupManagerResponse =
          await getPickupManagerParameterization({
            branchId: 1,
            transportTypeId: 9,
            pickupTypeId: 1,
            inputTypeId: 5
          });

        if (defaultPickupManagerResponse?.length > 0) {
          branchParameterizationId =
            defaultPickupManagerResponse[0]?.branchParameterizationId;
        }
      }

      if (!branchParameterizationId) return;

      // const materialListResponse = await getPickupManagerMaterialListEnabled({
      //   branchParameterizationId
      // });

      // if (materialListResponse.status === 200) {
      //   const { data: materialList } = materialListResponse?.data;

      //   const otherMaterial = materialList.find(
      //     ({ materialDescription }) =>
      //       materialDescription.toLowerCase() === 'outros'
      //   );

      //   setMaterialTypeList(materialList);

      //   otherMaterial && setOtherMaterialId(otherMaterial?.branchMaterialId);
      // }

      const checkListResponse = await getPickupManagerCheckList({
        branchParameterizationId
      });

      // if (checkListResponse.status === 200) {
      //   const newCheckList = checkListResponse?.data?.data
      //     ?.filter((value) => value.enabled === true)
      //     ?.map((value) => {
      //       const { data: materialList } = materialListResponse?.data;

      //       value.materialName = '-';

      //       const materialFounded = materialList.find(
      //         (element) => element.branchMaterialId === value.branchMaterialId
      //       );

      //       if (materialFounded) {
      //         value.materialName = materialFounded.materialDescription;
      //       }

      //       return value;
      //     });

      //   setCheckList(newCheckList);
      // }

      const validationResponse = await getPickupManagerBranchValidations({
        branchParameterizationId
      });

      if (
        validationResponse?.length > 0 &&
        validationResponse[0]?.enableGeneralChecklist === true
      ) {
        setCustomerAcceptGuidelines(false);
        setEnableCheckList(true);
      } else {
        setCustomerAcceptGuidelines(true);
        setEnableCheckList(false);
      }

      const scheduleResponse = await getPickupManagerBranchSchedules({
        branchParameterizationId
      });

      if (scheduleResponse?.length > 0) {
        if (scheduleResponse[0]?.enablePickupOnWeekends === true) {
          const { dateEnablePickupOnWeekends } = scheduleResponse[0];

          const hour = getHours(new Date(dateEnablePickupOnWeekends));

          setHourLimitOnWeekends(hour);
          setEnablePickupOnWeekends(true);
        } else {
          setHourLimitOnWeekends(0);
          setEnablePickupOnWeekends(false);
        }

        if (scheduleResponse[0]?.enablePickupOnHolidays === true) {
          const { dateEnablePickupOnHolidays } = scheduleResponse[0];

          const hour = getHours(new Date(dateEnablePickupOnHolidays));

          setHourLimitOnHolidays(hour);
          setEnablePickupOnHolidays(true);
        } else {
          setHourLimitOnHolidays(0);
          setEnablePickupOnHolidays(false);
        }

        if (scheduleResponse[0]?.enableTimeSlotTimeToPickupSchedule === true) {
          const { dateEnableTimeSlotTimeToPickupSchedule } =
            scheduleResponse[0];

          const hour = getHours(
            new Date(dateEnableTimeSlotTimeToPickupSchedule)
          );

          const minutes = new Date(
            dateEnableTimeSlotTimeToPickupSchedule
          ).getMinutes();

          setSlotTimeToPickupSchedule(hour);
          setMinuteSlotTimeToPickupSchedule(minutes);
          setEnableSlotTimeToPickupSchedule(true);
        } else {
          setSlotTimeToPickupSchedule(0);
          setMinuteSlotTimeToPickupSchedule(0);
          setEnableSlotTimeToPickupSchedule(false);
        }
      } else {
        setHourLimitOnWeekends(0);
        setEnablePickupOnWeekends(false);
        setHourLimitOnHolidays(0);
        setEnablePickupOnHolidays(false);
        setSlotTimeToPickupSchedule(0);
        setMinuteSlotTimeToPickupSchedule(0);
        setEnableSlotTimeToPickupSchedule(false);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }

    // if (isFirstRender) {
    //   collectLoadData.material &&
    //     setValue('material', collectLoadData.material);
    //   collectLoadData.material && setMaterialSelected(collectLoadData.material);
    // }

    if (
      (isFirstRender && !collectLoadData.loadAvailableDate) ||
      !isFirstRender
    ) {
      setValue('loadAvailableDate', null);
      setInputAvailableDate(null);
      setFromHours(hours);
      setValue('loadAvailableFrom', '');
      setToHours(hours);
      setValue('loadAvailableUntil', '');
      clearErrors([
        'loadAvailableDate',
        'loadAvailableFrom',
        'loadAvailableUntil'
      ]);
    }

    isFirstRender && setIsFirstRender(false);

    setIsLoadingMaterial(false);
  }, [transportSelected]);

  // useEffect(() => {
  //   if (!materialSelected) {
  //     return;
  //   }

  //   setCheckListSelected({});

  //   let newCheckListSelected = checkList?.find(
  //     (value) => value.branchMaterialId === materialSelected
  //   );

  //   if (newCheckListSelected) {
  //     if (newCheckListSelected?.agroupBy) {
  //       const { agroupBy } = newCheckListSelected;

  //       newCheckListSelected = checkList?.find(
  //         (value) => value.branchChecklistId === agroupBy
  //       );
  //     }

  //     setCheckListSelected(newCheckListSelected);
  //   }
  // }, [materialSelected]);

  return (
    <form onSubmit={handleSubmit(onNextStep)}>
      <Paper
        elevation={2}
        style={{
          position: 'relative',
          marginTop: 16,
          padding: '20px 16px 16px'
        }}
      >
        <Title>Dados da Carga:</Title>

        <Stack spacing={2}>
          <Stack direction={maxMD ? 'column' : 'row'} spacing={2}>
            <Stack
              direction={maxSM ? 'column' : 'row'}
              spacing={2}
              style={{ width: '100%' }}
            >
              <TooltipWrapper>
                {!isLoadingModal ? (
                  <Controller
                    name="modal"
                    defaultValue=""
                    control={control}
                    render={({ field }) => (
                      <FormControl error={!!errors.modal} fullWidth>
                        <InputLabel id="modal">Modal (*)</InputLabel>
                        <Select
                          id="modal"
                          label="Modal (*)"
                          {...field}
                          value={(field.value = transportSelected)}
                          onChange={(event) => {
                            const { value } = event.target;
                            setTransportSelected(value);
                            setTransportSelectedToModal(value);
                            field.onChange(value);
                          }}
                          error={!!errors.modal}
                        >
                          {transportTypeList.map(
                            ({ description, transportTypeId }) => (
                              <MenuItem
                                key={transportTypeId}
                                value={transportTypeId}
                              >
                                {description}
                              </MenuItem>
                            )
                          )}
                          {transportTypeList?.length === 0 && (
                            <MenuItem value="">Sem modais habilitados</MenuItem>
                          )}
                        </Select>
                        <FormHelperText>{errors.modal?.message}</FormHelperText>
                      </FormControl>
                    )}
                  />
                ) : (
                  <TextField
                    label="Modal (*)"
                    disabled
                    sx={{ width: '100%' }}
                    InputProps={{
                      endAdornment: (
                        <ReactLoading
                          type="spin"
                          color="#808080"
                          width={16}
                          height={16}
                        />
                      )
                    }}
                  />
                )}
                <TooltipIcon
                  title="Opções de locomoção de carga na Braspress."
                  placement="top"
                  className="tooltip"
                >
                  <i className="far fa-question-circle" />
                </TooltipIcon>
              </TooltipWrapper>

              <TooltipWrapper>
                <Controller
                  name="freight"
                  defaultValue=""
                  control={control}
                  render={({ field }) => (
                    <FormControl error={!!errors.freight} fullWidth>
                      <InputLabel id="freight">Tipo de Frete (*)</InputLabel>
                      <Select
                        id="freight"
                        label="Tipo de Frete (*)"
                        {...field}
                        error={!!errors.freight}
                      >
                        {freightTypeList.map(
                          ({ description, freight_Type_Id }) => (
                            <MenuItem
                              key={freight_Type_Id}
                              value={freight_Type_Id}
                            >
                              {description}
                            </MenuItem>
                          )
                        )}
                      </Select>
                      <FormHelperText>{errors.freight?.message}</FormHelperText>
                    </FormControl>
                  )}
                />
                <TooltipIcon
                  title="CIF: Quando o remetente é o pagante. FOB: Quando o destinatário é o pagante. Consignado: Quando o embarcador contrata um frete por intermédio de outro, sem contato direto com a transportadora. "
                  placement="top"
                  className="tooltip"
                >
                  <i className="far fa-question-circle" />
                </TooltipIcon>
              </TooltipWrapper>
              <TooltipWrapper>
                <Controller
                  name="loadVolume"
                  defaultValue=""
                  control={control}
                  render={({ field }) => (
                    <>
                      <TextField
                        label="N° de volumes (*)"
                        fullWidth
                        {...field}
                        onChange={(e) => {
                          const regex = /^[0-9]+$/;
                          if (
                            !e.target.value.match(regex) &&
                            e.target.value !== ''
                          ) {
                            return;
                          }

                          field.onChange(e.target.value);
                        }}
                        inputProps={{ maxLength: 4 }}
                        error={!!errors.loadVolume}
                        helperText={errors.loadVolume?.message}
                      />
                    </>
                  )}
                />
                <TooltipIcon
                  title="Mencionar a quantidade exata ou aproximada de volumes a serem transportados!"
                  placement="top"
                  className="tooltip"
                >
                  <i className="far fa-question-circle" />
                </TooltipIcon>
              </TooltipWrapper>

              <TooltipWrapper>
                <Controller
                  name="loadWeight"
                  defaultValue=""
                  control={control}
                  render={({ field }) => (
                    <>
                      <TextField
                        label="Peso total (*)"
                        fullWidth
                        {...field}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">kg</InputAdornment>
                          )
                        }}
                        onChange={(e) => {
                          if (e.target.value?.length > 9) {
                            return;
                          }

                          const parsedValue = formatInput(e.target.value);

                          field.onChange(parsedValue);
                        }}
                        onBlur={(e) => {
                          let { value } = e.target;

                          if (value !== '' && !value.includes(',')) {
                            value += ',00';
                          } else if (value.indexOf(',') === 0) {
                            value = `0${value}`;
                          }

                          field.onBlur(field.onChange(value));
                        }}
                        error={!!errors.loadWeight}
                        helperText={errors.loadWeight?.message}
                      />
                    </>
                  )}
                />
                <TooltipIcon
                  title="Mencionar o peso total exato ou total aproximado dos volumes a serem transportados!"
                  placement="top"
                  className="tooltip"
                >
                  <i className="far fa-question-circle" />
                </TooltipIcon>
              </TooltipWrapper>
            </Stack>

            {/* <Stack
              direction={maxSM ? 'column' : 'row'}
              spacing={2}
              style={{ width: '100%' }}
            >
              <TooltipWrapper>
                {!isLoadingModal && !isLoadingMaterial ? (
                  <Controller
                    name="material"
                    defaultValue=""
                    control={control}
                    render={({ field }) => (
                      <FormControl error={!!errors.material} fullWidth>
                        <InputLabel id="material">Material *</InputLabel>
                        <Select
                          id="material"
                          label="Material *"
                          {...field}
                          value={(field.value = materialSelected)}
                          onChange={(e) => {
                            handleChangeMaterialType(e.target.value);
                            // setCustomerAcceptGuidelines(false);
                            setMaterialSelected(e.target.value);
                            field.onChange(e.target.value);
                          }}
                          error={!!errors.material}
                        >
                          {materialTypeList.map(
                            ({ materialDescription, branchMaterialId }) => (
                              <MenuItem
                                key={branchMaterialId}
                                value={branchMaterialId}
                              >
                                {materialDescription}
                              </MenuItem>
                            )
                          )}
                        </Select>
                        <FormHelperText>
                          {errors.material?.message}
                        </FormHelperText>
                      </FormControl>
                    )}
                  />
                ) : (
                  <TextField
                    label="Material *"
                    disabled
                    sx={{ width: '100%' }}
                    InputProps={{
                      endAdornment: (
                        <ReactLoading
                          type="spin"
                          color="#808080"
                          width={16}
                          height={16}
                        />
                      )
                    }}
                  />
                )}
                <TooltipIcon
                  title="Informar o tipo de material que deseja transportar."
                  placement="top"
                  className="tooltip"
                >
                  <i className="far fa-question-circle" />
                </TooltipIcon>
              </TooltipWrapper>

              <TooltipWrapper>
                <Controller
                  name="MaterialDetail"
                  defaultValue=""
                  control={control}
                  render={({ field }) => (
                    <>
                      <TextField
                        label="Detalhes do material"
                        value=""
                        fullWidth
                        disabled={disabledMaterialDetail}
                        {...field}
                        inputProps={{ maxLength: 256 }}
                        error={!!errors.MaterialDetail}
                        helperText={errors.MaterialDetail?.message}
                      />
                    </>
                  )}
                />
                <TooltipIcon
                  title="Informe de forma sucinta o tipo de material que será transportado. Exemplo: Confecção Têxtil"
                  placement="top"
                  className="tooltip"
                >
                  <i className="far fa-question-circle" />
                </TooltipIcon>
              </TooltipWrapper>
            </Stack> */}
          </Stack>

          <Stack direction={maxMD ? 'column' : 'row'} spacing={2}>
            {/* <Stack
              direction={maxSM ? 'column' : 'row'}
              spacing={2}
              style={{ width: maxMD ? '100%' : '40%' }}
            > */}
            {/* <TooltipWrapper>
                <Controller
                  name="loadVolume"
                  defaultValue=""
                  control={control}
                  render={({ field }) => (
                    <>
                      <TextField
                        label="N° de volumes *"
                        fullWidth
                        {...field}
                        onChange={(e) => {
                          const regex = /^[0-9]+$/;
                          if (
                            !e.target.value.match(regex) &&
                            e.target.value !== ''
                          ) {
                            return;
                          }

                          field.onChange(e.target.value);
                        }}
                        error={!!errors.loadVolume}
                        helperText={errors.loadVolume?.message}
                      />
                    </>
                  )}
                />
                <TooltipIcon
                  title="Mencionar a quantidade exata ou aproximada de volumes a serem transportados!"
                  placement="top"
                  className="tooltip"
                >
                  <i className="far fa-question-circle" />
                </TooltipIcon>
              </TooltipWrapper>

              <TooltipWrapper>
                <Controller
                  name="loadWeight"
                  defaultValue=""
                  control={control}
                  render={({ field }) => (
                    <>
                      <TextField
                        label="Peso total *"
                        fullWidth
                        {...field}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">kg</InputAdornment>
                          )
                        }}
                        onChange={(e) => {
                          const parsedValue = formatInput(e.target.value);

                          field.onChange(parsedValue);
                        }}
                        onBlur={(e) => {
                          let { value } = e.target;

                          if (value !== '' && !value.includes(',')) {
                            value += ',00';
                          } else if (value.indexOf(',') === 0) {
                            value = `0${value}`;
                          }

                          field.onBlur(field.onChange(value));
                        }}
                        error={!!errors.loadWeight}
                        helperText={errors.loadWeight?.message}
                      />
                    </>
                  )}
                />
                <TooltipIcon
                  title="Mencionar o peso total exato ou total aproximado dos volumes a serem transportados!"
                  placement="top"
                  className="tooltip"
                >
                  <i className="far fa-question-circle" />
                </TooltipIcon>
              </TooltipWrapper> */}
            {/* </Stack> */}

            {/* <Stack
              direction={maxSM ? 'column' : 'row'}
              spacing={2}
              style={{ width: maxMD ? '100%' : '60%' }}
            >
              <TooltipWrapper>
                <Controller
                  name="loadHeight"
                  defaultValue=""
                  control={control}
                  render={({ field }) => (
                    <>
                      <TextField
                        label="Altura *"
                        fullWidth
                        {...field}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">cm</InputAdornment>
                          )
                        }}
                        onChange={(e) => {
                          const parsedValue = formatInput(e.target.value);

                          field.onChange(parsedValue);
                        }}
                        onBlur={(e) => {
                          let { value } = e.target;

                          if (value !== '' && !value.includes(',')) {
                            value += ',00';
                          } else if (value.indexOf(',') === 0) {
                            value = `0${value}`;
                          }

                          field.onBlur(field.onChange(value));
                        }}
                        error={!!errors.loadHeight}
                        helperText={errors.loadHeight?.message}
                      />
                    </>
                  )}
                />
                <TooltipIcon
                  title="Mencionar a altura exata ou altura aproximada dos volumes a serem transportados!"
                  placement="top"
                  className="tooltip"
                >
                  <i className="far fa-question-circle" />
                </TooltipIcon>
              </TooltipWrapper>

              <TooltipWrapper>
                <Controller
                  name="loadWidth"
                  defaultValue=""
                  control={control}
                  render={({ field }) => (
                    <>
                      <TextField
                        label="Largura *"
                        fullWidth
                        {...field}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">cm</InputAdornment>
                          )
                        }}
                        onChange={(e) => {
                          const parsedValue = formatInput(e.target.value);

                          field.onChange(parsedValue);
                        }}
                        onBlur={(e) => {
                          let { value } = e.target;

                          if (value !== '' && !value.includes(',')) {
                            value += ',00';
                          } else if (value.indexOf(',') === 0) {
                            value = `0${value}`;
                          }

                          field.onBlur(field.onChange(value));
                        }}
                        error={!!errors.loadWidth}
                        helperText={errors.loadWidth?.message}
                      />
                    </>
                  )}
                />
                <TooltipIcon
                  title="Mencionar a largura exata ou largura aproximada dos volumes a serem transportados!"
                  placement="top"
                  className="tooltip"
                >
                  <i className="far fa-question-circle" />
                </TooltipIcon>
              </TooltipWrapper>

              <TooltipWrapper>
                <Controller
                  name="loadLength"
                  defaultValue=""
                  control={control}
                  render={({ field }) => (
                    <>
                      <TextField
                        label="Comprimento *"
                        fullWidth
                        {...field}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">cm</InputAdornment>
                          )
                        }}
                        onChange={(e) => {
                          const parsedValue = formatInput(e.target.value);

                          field.onChange(parsedValue);
                        }}
                        onBlur={(e) => {
                          let { value } = e.target;

                          if (value !== '' && !value.includes(',')) {
                            value += ',00';
                          } else if (value.indexOf(',') === 0) {
                            value = `0${value}`;
                          }

                          field.onBlur(field.onChange(value));
                        }}
                        error={!!errors.loadLength}
                        helperText={errors.loadLength?.message}
                      />
                    </>
                  )}
                />
                <TooltipIcon
                  title="Mencionar o comprimento exato ou comprimento aproximado dos volumes a serem transportados!"
                  placement="top"
                  className="tooltip"
                >
                  <i className="far fa-question-circle" />
                </TooltipIcon>
              </TooltipWrapper>
            </Stack> */}
          </Stack>

          {enableCheckList && (
            <Stack direction={maxSM ? 'column' : 'row'} spacing={maxSM ? 1 : 3}>
              <button
                type="button"
                style={{
                  marginTop: 11,
                  display: 'flex',
                  color: '#444444',
                  fontWeight: 'bold',
                  backgroundColor: 'transparent',
                  border: 'none',
                  outline: 'none'
                }}
                disabled={!checkListSelected?.branchChecklistId}
                onClick={() => {
                  openAcceptTransportTermsModal();
                }}
              >
                Orientações gerais de transporte
              </button>

              <Controller
                name="acceptTerms"
                control={control}
                defaultValue
                render={({ field }) => (
                  <Stack>
                    <FormControlLabel
                      label="Cliente ciente das orientações"
                      style={{ color: '#004e9a' }}
                      control={
                        // eslint-disable-next-line react/jsx-wrap-multilines
                        <Checkbox
                          {...field}
                          value="true"
                          disabled={!checkListSelected?.branchChecklistId}
                          checked={customerAcceptGuidelines}
                          onClick={() => {
                            openAcceptTransportTermsModal();
                          }}
                        />
                      }
                    />
                  </Stack>
                )}
              />
            </Stack>
          )}
        </Stack>

        <Title style={{ marginTop: 24 }}>
          Data e Hora que a Carga Estará Disponível:
        </Title>

        <Stack
          direction={maxMD ? 'column' : 'row'}
          spacing={2}
          style={{ alignItems: 'flex-start' }}
        >
          <Stack
            direction={maxSM ? 'column' : 'row'}
            spacing={2}
            style={{ width: maxMD && '100%' }}
          >
            <TooltipWrapper>
              <Controller
                name="loadAvailableDate"
                defaultValue=""
                control={control}
                render={({ field }) => (
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    adapterLocale={ptBRLocale}
                  >
                    <DatePicker
                      label="Data"
                      mask="__/__/____"
                      {...field}
                      value={(field.value = inputAvailableDate)}
                      onChange={(value) => {
                        setInputAvailableDate(value);
                        field.onChange(value);
                      }}
                      shouldDisableDate={disableDays}
                      maxDate={addDays(new Date(), 30)}
                      minDate={new Date(addDays(new Date(), 1))}
                      disabled={isLoadingModal || isLoadingMaterial}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          onBlur={(event) => {
                            if (
                              event?.target?.value?.length >= 8 &&
                              event?.target?.value?.length < 10
                            ) {
                              const [day, month, year] =
                                event.target.value.split('/');

                              const newDate = new Date(
                                `20${year?.replace(/^0+/, '')}`,
                                month - 1,
                                day
                              );

                              setInputAvailableDate(newDate);
                              setValue('loadAvailableDate', newDate);
                            }
                          }}
                          inputProps={{
                            ...params.inputProps,
                            placeholder: 'DD/MM/AAAA'
                          }}
                          style={{
                            width: maxMD ? '100%' : 192,
                            maxWidth: !maxMD && 192
                          }}
                          error={!!errors.loadAvailableDate}
                          helperText={errors.loadAvailableDate?.message}
                        />
                      )}
                    />
                  </LocalizationProvider>
                )}
              />
            </TooltipWrapper>
            <TooltipWrapper>
              <Controller
                name="loadAvailableFrom"
                defaultValue=""
                control={control}
                render={({ field }) => (
                  <FormControl
                    error={!!errors.loadAvailableFrom}
                    style={{
                      width: maxMD ? '100%' : 128,
                      maxWidth: !maxMD && 128
                    }}
                  >
                    <InputLabel id="loadAvailableFrom">A partir de</InputLabel>
                    <Select
                      id="loadAvailableFrom"
                      label="A partir de"
                      {...field}
                      disabled={
                        isLoadingMaterial ||
                        inputAvailableDate === null ||
                        !isValid(new Date(inputAvailableDate)) ||
                        format(new Date(inputAvailableDate), 'yyyy')?.replace(
                          /^0+/,
                          ''
                        )?.length < 4
                      }
                      error={!!errors.loadAvailableFrom}
                    >
                      {fromHours.map(({ id, hour }) => (
                        <MenuItem key={id} value={hour}>
                          {hour}
                        </MenuItem>
                      ))}
                      {fromHours?.length === 0 && (
                        <MenuItem value="disabled" disabled>
                          Sem horários disponíveis
                        </MenuItem>
                      )}
                    </Select>
                    <FormHelperText>
                      {errors.loadAvailableFrom?.message}
                    </FormHelperText>
                  </FormControl>
                )}
              />
            </TooltipWrapper>
            <TooltipWrapper>
              <Controller
                name="loadAvailableUntil"
                defaultValue=""
                control={control}
                render={({ field }) => (
                  <FormControl
                    error={!!errors.loadAvailableUntil}
                    style={{
                      width: maxMD ? '100%' : 128,
                      maxWidth: !maxMD && 128
                    }}
                  >
                    <InputLabel id="loadAvailableUntil">Até</InputLabel>
                    <Select
                      id="loadAvailableUntil"
                      label="Até"
                      {...field}
                      disabled={
                        isLoadingMaterial ||
                        inputAvailableDate === null ||
                        !isValid(new Date(inputAvailableDate)) ||
                        format(new Date(inputAvailableDate), 'yyyy')?.replace(
                          /^0+/,
                          ''
                        )?.length < 4
                      }
                      error={!!errors.loadAvailableUntil}
                    >
                      {toHours.map(({ id, hour }) => (
                        <MenuItem key={id} value={hour}>
                          {hour}
                        </MenuItem>
                      ))}
                      {toHours?.length === 0 && (
                        <MenuItem value="disabled" disabled>
                          Sem horários disponíveis
                        </MenuItem>
                      )}
                    </Select>
                    <FormHelperText>
                      {errors.loadAvailableUntil?.message}
                    </FormHelperText>
                  </FormControl>
                )}
              />

              <TooltipIcon
                title="O período informado nestes campos, representa uma estimativa da disponibilidade da mercadoria, não refere-se a data ou horário em que será coletada."
                placement="top"
                className="tooltip"
              >
                <i className="far fa-question-circle" />
              </TooltipIcon>
            </TooltipWrapper>
          </Stack>

          <Button
            type="button"
            onClick={openReceiveCollectInfoModal}
            style={{
              height: 56,
              marginLeft: !maxMD && 'auto'
            }}
          >
            Receber informações da coleta
          </Button>
        </Stack>
      </Paper>

      <StepButtons nextFunction={handleSubmit(onNextStep)} />
    </form>
  );
};
